import { useMutation } from '@tanstack/react-query';
import { fetchData } from '../../../utils';
import useError from '../../useError';
import useSmartlook from '../../useSmartlook';
import { Occupation } from './useClientEmploymentDetails';

export function useClientEmploymentDetailsMutation() {
  const { showError } = useError();
  const { error } = useSmartlook();

  return useMutation<Occupation[], unknown>({
    mutationFn: async () => {
      try {
        const resp = await fetchData('/employment/employmentDetails', {
          method: 'get',
        });

        return resp;
      } catch (e) {
        error(
          '[useClientEmploymentDetailsMutation][GET /employment/employmentDetails]',
          e,
        );
        showError();
        throw e;
      }
    },
  });
}
